<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
    >
      <template v-slot:updateInfo="{ row }">
        <span>{{ row.updateByName }}</span>
        <br />
        <span>{{ row.updateTime }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  computed: {
    height() {
      const minHeight = 500
      const height = this.tableHeight
      return height < minHeight ? minHeight : height
    },
  },
}
</script>
